import React from 'react';
import { Table, Space, Typography, Tag, Button } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { getStatusColor } from '../utils/theme';
import { useNavigate } from 'react-router-dom';


const { Title, Text } = Typography;

const OrdersTable = ({ orders }) => {
  const orderColumns = [
    {
      title: 'Order ID',
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: 'Supplier',
      dataIndex: 'supplier',
      key: 'supplier',
      render: (text) => <Text strong>{text}</Text>,
    },
    {
      title: 'Items',
      dataIndex: 'items',
      key: 'items',
    },
    {
      title: 'Date',
      dataIndex: 'date',
      key: 'date',
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (status) => <Tag color={getStatusColor(status)}>{status}</Tag>,
    },
    {
      title: 'Total',
      dataIndex: 'total',
      key: 'total',
    },
    {
      title: 'Actions',
      key: 'actions',
      render: () => (
        <Space>
          <Button size="small">Track</Button>
          <Button size="small">Details</Button>
        </Space>
      ),
    },
  ];
  const navigate = useNavigate();

  return (
    <>
      <Space style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '16px' }}>
        <Title level={4} style={{ margin: 0 }}>
          Medication Orders
        </Title>
        <Button type="primary" icon={<PlusOutlined />} onClick={() => navigate('/orders/new')}>
  New Order
</Button>

      </Space>

      <Table
        columns={orderColumns}
        dataSource={orders}
        rowKey="id"
        pagination={{
          position: ['bottomRight'],
          showSizeChanger: true,
          pageSizeOptions: ['10', '20', '50'],
          showTotal: (total) => `Showing ${orders.length} of ${total} orders`,
        }}
      />
    </>
  );
};

export default OrdersTable;
